import React, { useState } from "react";

import { Row, Col, FormControl, Checkbox, Modal } from "react-bootstrap";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

export default function Actions() {
  const { dispatch, actions, state } = useEditCoachPoolContext();
  let [loader, setLoader] = useState(false);

  const saveData = (e) => {
    setLoader(true);

    actions.updateCoachPool(
      dispatch,
      state.coachPool,
      {
        name: state.coachPool.attributes.name,
        default: state.coachPool.attributes.default,
        coache_ids: state.coachSelected,
      },
      () => {
        setLoader(false);
        toastr["info"]("Coach Pool was successfully updated.");
        if (state.backUrl == null) {
          actions.showCoachPool(state.coachPool.id);
        } else {
          document.location.href = state.backUrl;
        }
      },
      () => {
        setLoader(false);
      }
    );
  };

  const cancelSave = (e) => {
    if (state.formCanged) {
      swal(
        {
          title: "",
          text: "Changes you made may not be saved. Do you want to save changes before leaving?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Save",
          cancelButtonText: "Continue without Saving",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            saveData(e);
          } else {
            actions.showCoachPool(state.coachPool.id);
          }
        }
      );
    } else {
      actions.showCoachPool(state.coachPool.id);
    }
  };

  return (
    <>
      <div className="mt20 text-right">
        <a onClick={cancelSave} className="btn btn-green w-150">
          Cancel
        </a>
        <a
          onClick={saveData}
          className={`btn btn-green w-150 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        >
          Save
        </a>
      </div>
      <Modal className="student inmodal auto without-overflow" show={loader}>
        <Modal.Body className="text-center">
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "4em" }}></i>
          <h3>Please wait ...</h3>
        </Modal.Body>
      </Modal>
    </>
  );
}
